// extracted by mini-css-extract-plugin
export default {"overlay":"Modal_overlay__r63M6","modal":"Modal_modal__DJDMv","img":"Modal_img__20InI","description":"Modal_description__zKB3H"};